import { Box, Paper, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import UpcomingEvents from '../events/UpcomingEvents';
import GradientHeader from '../common/GradientHeader';

const EventsSidebar = ({ events }) => {
  const navigate = useNavigate();
  
  const handleEventClick = (event) => {
    navigate(`/events`, { state: { event } });
  };
  
  return (
    <Paper
      elevation={2}
      sx={{
        borderRadius: '12px',
        background: 'white',
      }}
    >
      <GradientHeader title="Próximos Eventos" icon="📅" />
      
      <Box sx={{ p: 2 }}>
        {events.length === 0 ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 4,
              textAlign: 'center',
            }}
          >
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              No hay eventos próximos
            </Typography>
          </Box>
        ) : (
          <Box>
            {events.slice(0, 3).map((event) => (
              <Box
                key={event.id_events}
                onClick={() => handleEventClick(event)}
                sx={{
                  cursor: 'pointer',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  '&:hover': {
                    transform: 'translateX(4px)',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  },
                  mb: 2,
                }}
              >
                <UpcomingEvents event={event} />
              </Box>
            ))}
          </Box>
        )}
      </Box>
      
      {events.length > 0 && (
        <Box
          sx={{
            p: 2,
            pt: 0,
            borderBottomLeftRadius: '12px',
            borderBottomRightRadius: '12px',
          }}
        >
          <Button
            fullWidth
            variant="outlined"
            size="small"
            sx={{
              background: 'linear-gradient(to right, #09274A, #0488AF)',
              color: '#fff',
              textTransform: 'none',
              minHeight: '36px',
              padding: '6px 16px',
              lineHeight: '1.5',
              '&:hover': {
                background: 'linear-gradient(to right, #071f3d, #03779C)',
              },
            }}
            onClick={() => navigate('/events')}
          >
            Ver todos los eventos
          </Button>
        </Box>
      )}
    </Paper>
  );
};

export default EventsSidebar;